module.exports = __webpack_public_path__ + "static/full-logo-light-e84c164819279717e4fb312b9fe77c0d.png";